import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-radio-component',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
})
export class RadioComponent {
  @Input() checked: boolean;
  @Input() title: string;
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  check(): void {
    this.onChange.emit(this.title);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/RadioComponent/radio.component.ts